import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_140: FaireProductEntity = {
  token: "legacy_prod_abbott-140",
  type: "product",
  name: "Butterfly Garden Canister-5.5 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c5b820a852ff12af05813d0366889551a3702cb645d17acd654a2537f7d45176.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
